import { Typography } from "@mui/material";
import AppButton from "component/button/AppButton";
import React from "react";
import styles from "./Disclaimer.module.css";

function Disclaimer() {
  const handleRedirect = () => {
    window.location.replace('https://stanbicibtchomeloans.rese.africa/', )
  };
  return (
    <div className={styles.disclaimer}>
      <Typography>
        By accessing the link for Property Listings, the link will bring you to
        a Third-party website, owned and operated by an independent party over
        which Stanbic IBTC Bank PLC has no control ("site"). Any connections you
        make to or from the site will be at your own risk and solely at your
        discretion. Any use of the site will be subject to and any information
        you provide will be governed by the terms of the Third-Party site,
        including those relating to confidentiality, data privacy and security.
        All information or communication on the website is between You and that
        Third Party, Stanbic IBTC Bank PLC makes no representations about any
        information or other websites that may be accessed from this Site.
        Stanbic IBTC Bank PLC has no control over the contents of the Site, are
        not in any way associated with the owner or operator of the site or
        responsible or liable for the goods and services offered by them or for
        anything in connection with such site. Stanbic IBTC Bank PLC does not
        endorse or approve and makes no warranties, representations or
        undertakings relating to the content of the site. UNDER NO CIRCUMSTANCE
        SHALL STANBIC IBTC BANK PLC BE LIABLE FOR ANY LOSS OR DAMAGE OF ANY KIND
        INCURRED AS A RESULT OF YOUR USE OF THE SITE
      </Typography>
      <div className={styles.btn}>
        <AppButton
          width={"180px"}
          handleAction={() => {
            handleRedirect();
          }}
          textColor="#FFFFFF"
          btnBg="#0072CE"
          btnText="I understand"
        />
      </div>
    </div>
  );
}

export default Disclaimer;